import React from 'react';
import type { FrequencyEnum } from 'venn-api';
import { formatDateByFrequency } from '../../../manage-data';

type BulkManageAxisRowRangeCellProps = {
  earliestStart: number;
  latestEnd: number;
  frequency: FrequencyEnum;
};
export const BulkManageAxisRowRangeCell = ({
  earliestStart,
  latestEnd,
  frequency,
}: BulkManageAxisRowRangeCellProps) => (
  <div className="absolute -top-[3px] -left-[3px] w-[calc(100%+6px)]">
    <div className="flex justify-between">
      <div className="w-[6px] h-[6px] bg-venn-grey-80 rounded-full border border-solid border-white" />
      <div className="w-[6px] h-[6px] bg-venn-grey-80 rounded-full border border-solid border-white" />
      <div className="w-[6px] h-[6px] bg-venn-grey-80 rounded-full border border-solid border-white" />
    </div>
    <div className="flex justify-between font-bold text-venn-grey-80 text-[11px]">
      <div>{formatDateByFrequency(earliestStart, frequency)}</div>
      <div>{formatDateByFrequency((earliestStart + latestEnd) / 2, frequency)}</div>
      <div>{formatDateByFrequency(latestEnd, frequency)}</div>
    </div>
  </div>
);
